module.exports = "<p>\n  divisiones works!\n</p>\n"